// @generated by protoc-gen-connect-query v2.2.0 with parameter "target=ts"
// @generated from file catpocs/v1/settings.proto (package catpocs.v1, syntax proto3)
/* eslint-disable */

import { SettingsService } from "./settings_pb";

/**
 * GetSettings retrieves current settings
 *
 * @generated from rpc catpocs.v1.SettingsService.GetSettings
 */
export const getSettings = SettingsService.method.getSettings;

/**
 * UpdateSettings updates operator settings
 *
 * @generated from rpc catpocs.v1.SettingsService.UpdateSettings
 */
export const updateSettings = SettingsService.method.updateSettings;

/**
 * TestNotifications sends a test notification
 *
 * @generated from rpc catpocs.v1.SettingsService.TestNotifications
 */
export const testNotifications = SettingsService.method.testNotifications;
